export const FULLSCREEN_STYLEPARAMS_KEYS = [
  'defaultShowInfoExpand',
  'allowTitleExpand',
  'allowDescriptionExpand',
  'allowLinkExpand',
  'expandInfoPosition',
  'allowFullscreenExpand',
  'fullscreenLoop',
  'bgColorExpand',
  'actionsColorExpand',
  'titleFontExpand',
  'titleColorExpand',
  'descriptionFontExpan',
  'descriptionColorExpand',
  'galleryAlignExpand',
  'addToCartBackColorExpand',
  'addToCartFontExpand',
  'addToCartColorExpand',
  'addToCartBorderWidth',
  'addToCartBorderColor',
];
